import { ContactType } from "../../lib/filters/dto";
import { PillsColor } from "../../ui/molecules/pills/Pills.types";
import { ItemsPerPageValues } from "../../ui/organisms/pagination/dto";
import { ParticularityDTO } from "../particularities/dto";
import { ProjectDTO } from "../projects/dto";
import { UserDTO } from "../users/dto";

export interface TargetListDTO {
  categories: string[] | null;
  sectors: string[] | null;
  commercials: UserDTO[];
  commercialIds: string[] | null;
  createdAt: Date | null;
  deletedAt: Date | null;
  departments: string[];
  employeesNumber: string;
  id: string;
  name: string;
  particularity: ParticularityDTO | null
  projectId: string;
  revenue: string;
  roles: string[];
  state: TargetListStatusEnum;

  contacts: number;
  leads: number;
  drafts: number;
  project: ProjectDTO;

}

export enum ContactStateEnum {
  DRAFT = "DRAFT",
  LEADTAKEN = "LEADTAKEN",
  TORECALL = "TORECALL",
  NORESPONSE = "NORESPONSE",
  KO = "KO",
  OPPOSITIONS = "OPPOSITIONS",
  INCORRECT = "INCORRECT",
}

export interface TargetListContactInfo {
  contactId: string;
  contactState: ContactStateEnum;
  lastContactDate: null | Date;
  notes: null | NoteDTO[];
  stateInfo: null | string
  callAttempts: null | number;
  createdAt: null | Date;
  deletedAt: null | Date
  id: null | string
}

export interface NoteDTO {
  note: string,
  date: string,
  authorUserId: string
}

export function stateInfoMap(state: ContactStateEnum): string[] {
  const StateInfoMap = new Map<ContactStateEnum, string[]>([
    [ContactStateEnum.DRAFT, []],
    [ContactStateEnum.LEADTAKEN, []],
    [ContactStateEnum.TORECALL, ["Mail generica inviata", "In giornata", "Mail diretta inviata", "Decisore assente", "Decisore in gestione"]],
    [ContactStateEnum.KO, ["Primo filtro insuperabile", "Decisore non interessato", "Non in target"]],
    [ContactStateEnum.INCORRECT, ["Centralino/inesistente/errato", "Fatturato", "Dipendenti", "Referente da verificare", "Settore", "Zona geografica", "Info errate e aggiornate", "Numero errato"]],
    [ContactStateEnum.OPPOSITIONS, []],
    [ContactStateEnum.NORESPONSE, []],
  ])

  return StateInfoMap.get(state)!
}

export const outcomeLabelMap = new Map<ContactStateEnum, string>([
  [ContactStateEnum.DRAFT, "Da lavorare"],
  [ContactStateEnum.LEADTAKEN, "Lead preso"],
  [ContactStateEnum.TORECALL, "Da richiamare"],
  [ContactStateEnum.KO, "Ko"],
  [ContactStateEnum.INCORRECT, "Info errate"],
  [ContactStateEnum.OPPOSITIONS, "Registro opposizioni"],
  [ContactStateEnum.NORESPONSE, "Nessuna risposta"],
]);

export function generateOutcomeOptions(
  count: null | number,
  noResponseCount: null | number,
  contactState: ContactStateEnum,
  type: ContactType
) {
  const outcomes = Object.values(ContactStateEnum);

  let options: { label: string; options: { label: string; value: string }[] }[] =
    [];

  outcomes.forEach((outcome) => {
    if (contactState !== ContactStateEnum.LEADTAKEN && outcome === ContactStateEnum.LEADTAKEN) {
      return;
    }

    const microOutcomes = stateInfoMap(outcome);

    if (microOutcomes.length === 0) {
      if (outcome === ContactStateEnum.NORESPONSE) {
        options.push({
          label: outcomeLabelMap.get(outcome)!,
          options: [{ label: outcomeLabelMap.get(outcome)! + (noResponseCount ? ` - Rec ${noResponseCount}` : ''), value: outcome.toString() }],
        });
      } else {
        options.push({
          label: outcomeLabelMap.get(outcome)!,
          options: [{ label: outcomeLabelMap.get(outcome)!, value: outcome.toString() }],
        });
      }
    } else {
      options.push({ label: outcomeLabelMap.get(outcome)!, options: [] });
      microOutcomes.forEach((micro) => {
        // if (type === ContactType.PERSON && outcome === ContactStateEnum.INCORRECT && micro !== 'Ruolo' && micro !== 'Altro') {
        //   return
        // }
        if (type === ContactType.COMPANY && outcome === ContactStateEnum.KO && micro === 'Registro opposizioni') {
          return
        }
        let microLabel = micro;
        if ((micro === "Richiamo" || micro === "Decisore assente") && count && count > 0) {
          microLabel = micro + " (" + count + ")";
        }
        options[options.length - 1].options.push({ label: microLabel, value: outcome + '::' + micro });
      });
    }
  });
  return options;
}


export function generateDefaultValue(contactState: ContactStateEnum, stateInfo: string | null) {
  if (contactState === ContactStateEnum.DRAFT || contactState === ContactStateEnum.LEADTAKEN || contactState === ContactStateEnum.NORESPONSE || contactState === ContactStateEnum.OPPOSITIONS) {
    return contactState
  } else {
    return (contactState + '::' + stateInfo)
  }
}

export interface FindAllTargetListsResponse {
  data: TargetListDTO[];
  next: boolean;
  page: number;
  perPage: number;
  prev: false;
  total: number;
  totalPage: number;
}

export interface FindAllTargetListsFilters {
  commercial: string[];
  contacts?: string;
  itemsPerPage: ItemsPerPageValues;
  name?: string;
  project: string[];
  order: boolean;
  page: number;
  sector: string[];
  category: string[];
  sort: keyof TargetListDTO;
  state: TargetListStatusEnum[];
  teamLeader: string[];
}

export interface EditTargetListRequest {
  name: string,
  commercialIds: string[],
  revenue: string,
  employeesNumber: string,
  particularityId?: string,
  departments: string[],
  roles: string[],
  sectors: string[],
  categories: string[],
}

export interface NewTargetListRequest {
  projectId: string;
  name: string;
  commercialIds: string[];
  departments: string[];
  roles: string[];
  revenue: string;
  employeesNumber: string;
  particularityId: string | null;
  sectors: string[];
  categories: string[];
}

export enum TargetListPageEnum {
  LIST,
  ADD,
  CSV,
  DB,
  TL,
}

export enum TargetListStatusEnum {
  TOSTART = "TOSTART",
  INPROGRESS = "INPROGRESS",
  SUSPENDED = "SUSPENDED",
  CONCLUDED = "CONCLUDED",
}

export interface ImportPersonDTO {
  name: string[];
  surname: string[];
  role: string[];
  department: string[];
  phone: string[];
  linkedinProfile: string[];
  privacy: string[];
  companyName: string[];
  notes: string[];
  lastContactDate: string[];
  email: string[];
  companyVat: string[];
  companyPhone: string[];
  contactState: string[];
  particularities: string[]
  stateInfo: string[];
}

export interface ImportCompanyDTO {
  name: string[];
  vat: string[];
  address: string[];
  zipCode: string[];
  city: string[];
  province: string[];
  countryRegion: string[];
  state: string[];
  email: string[];
  website: string[];
  revenue: string[];
  employeesNumber: string[];
  atecoCode: string[];
  atecoDescription: string[];
  sector: string[];
  category: string[];
  phone: string[];
  phoneNote: string[]
  contactState: string[];
  particularities: string[]
  lastContactDate: string[];
  notes: string[];
  stateInfo: string[];
}

export const targertListsStatePillMap = new Map<
  TargetListStatusEnum,
  { label: string; color: PillsColor }
>([
  [TargetListStatusEnum.TOSTART, { label: "Da iniziare", color: "gray" }],
  [TargetListStatusEnum.CONCLUDED, { label: "Concluso", color: "red" }],
  [TargetListStatusEnum.INPROGRESS, { label: "In corso", color: "blue" }],
  [TargetListStatusEnum.SUSPENDED, { label: "Sospeso", color: "orange" }],
]);

export const contactsStatePillMap = new Map<
  ContactStateEnum,
  { label: string; color: PillsColor }
>([
  [ContactStateEnum.DRAFT, { label: "Da lavorare", color: "blue" }],
  [ContactStateEnum.INCORRECT, { label: "Info errate", color: "gray" }],
  [ContactStateEnum.KO, { label: "Ko", color: "red" }],
  [ContactStateEnum.LEADTAKEN, { label: "Lead preso", color: "green" }],
  [ContactStateEnum.TORECALL, { label: "Da richiamare", color: "orange" }],
]);

export const columnOrderMapKey = new Map<string, string>([
  ["Settore", "sector"],
  ["Nome", "name"],
  ["Team Leader", "project.teamLeader.name"],
  ["Commerciali", "commercials.name"],
  ["Contatti", "contacts"],
  ["Lead", "contacts"],
  ["Da lavorare", "contacts"],
  ["Stato", "state"],
]);

export const columnOrderTargetPeopleMapKey = new Map<string, string>([
  ['Nome referente', 'name'],
  ['Cognome referente', 'surname'],
  ['Linkedin', ''],
  ['Ruolo', 'role'],
  ['Data di contatto', 'lastContactDate'],
  ['Esito', ''],
  ['Note', ''],
  ['Smartphone', 'phone'],
  ['Azienda', 'companyName'],
  ['Particolarità', 'particularity'],
  ['Reparto', 'department'],
  ['Privacy', ''],
  ['Email', 'email'],
])


export const columnOrderTargetCompaniesMapKey = new Map<string, string>([
  ['Nome azienda', 'name'],
  ['Data di contatto', 'lastContactDate'],
  ['Fatturato', 'revenue'],
  ['Telefono', 'phone'],
  ['Esito', ''],
  ['Particolarità', 'particularity'],
  ['Note', ''],
  ['Email', 'email'],
  ['Dipendenti', 'employeesId.lenght'],
  ['P. IVA', 'vat'],
  ['Sede azienda', 'address'],
  ['Sito web', ''],
  ['Cod. ATECO', 'atecoCode'],
  ['Settore', 'sector'],
  ['Categoria', 'category'],
  ['CAP', 'zipCode'],
])

